const BaseModule = require('../../90_utils/base/BaseModule');

class LeftGoop extends BaseModule {

	constructor(el, params) {
		super(el);
	}

	// basemodule

	_domReady(){

		let $goop = this.$el;
		let $goopPath = $goop.find('#bulge-path');
		let $gradient = $goop.find('#left-gradient');
		let $gradientStops = $gradient.find('stop');

		$gradientStops.eq(0).attr('stop-color', '#f6379a');
		$gradientStops.eq(1).attr('stop-color', '#25c4f6');
	}

	_addListeners(){ }
	_removeListeners(){ }

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = LeftGoop;
